import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { breakpoints } = theme;

  return {
    rowCell: {
      display: "flex",
      alignItems: "center",
      padding: "0 4px",
      minHeight: 28,
      fontSize: 14,
      wordBreak: "break-all"
    },
    rowCellBold: {
      justifyContent: "center",
      fontWeight: "bold"
    },
    rowCellCentered: {
      justifyContent: "center"
    },
    fadedOut: {
      color: "#babac0"
    },
    lastOneColumnCell: {
      minWidth: 116,
      [breakpoints.down(Breakpoints.XS_420)]: {
        minWidth: 60
      }
    },
    lastTwoColumnsCell: {
      minWidth: 168,
      [breakpoints.down(Breakpoints.XS_420)]: {
        minWidth: 120
      }
    }
  };
});
